import { render, staticRenderFns } from "./3d.vue?vue&type=template&id=3030f229&scoped=true&"
import script from "./3d.vue?vue&type=script&lang=js&"
export * from "./3d.vue?vue&type=script&lang=js&"
import style0 from "./3d.vue?vue&type=style&index=0&id=3030f229&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3030f229",
  null
  
)

export default component.exports